const debounce = (fn, delay) => {
  let timeoutID = null;
  return (...args) => {
    clearTimeout(timeoutID);
    const that = this;
    timeoutID = setTimeout(() => {
      fn.apply(that, args);
    }, delay);
  };
};

export {
  debounce, // eslint-disable-line import/prefer-default-export
};
